export const SET_PROGRAM_REGISTRATION_FIELDS =
  "SET_PROGRAM_REGISTRATION_FIELDS";

export const SET_LOADED_STATUS = "SET_LOADED_STATUS";

export const SET_CREATE_TEAM_AFTER_SIGN_IN = "SET_CREATE_TEAM_AFTER_SIGN_IN";

export const SET_CREATE_TEAM_FORM_DATA = "SET_CREATE_TEAM_FORM_DATA";
